import { isClientNode } from '../../../functions/client-model/client-node/is-client-node';
import { isLeafNode } from '../../../functions/client-model/client-node/is-leaf-node';
import { ClientBoard } from '../../../model/client-model/client-board';
import { ClientNode } from '../../../model/client-model/client-node';
import { ClientBoardContainer } from '../../../public/dashboard/shared/model/client-board-container';
import { DashboardNodeV4 } from '../../../public/dashboard/shared/model/dashboard-node-v4/dashboard-node-v4';
import { DashboardV4 } from '../../../public/dashboard/shared/model/dashboard-v4';
import { DashboardNodeV3 } from '../../../public/dashboard/v3/dashboard-node-v3';
import { DashboardV3 } from '../../../public/dashboard/v3/dashboard-v3';
import { getNode } from './get-node';

export function getLeafNodes(board?: DashboardV3, node?: DashboardNodeV3): DashboardNodeV3[];
export function getLeafNodes(board?: DashboardV4, node?: DashboardNodeV4): DashboardNodeV4[];
export function getLeafNodes(board?: ClientBoardContainer, node?: ClientNode): ClientNode[];
export function getLeafNodes(board?: ClientBoardContainer, node?: ClientNode): ClientNode[] {
  if (node && isLeafNode(node)) {
    return [];
  }
  if (!board) {
    return [];
  }
  const root: ClientNode | ClientBoard = node ?? board;
  return _getLeaves(root, board);
}

function _getLeaves(node: ClientNode | ClientBoard, board: DashboardV3 | ClientBoardContainer): ClientNode[] {
  if (isClientNode(node) && isLeafNode(node)) {
    return [node];
  }
  return node.childNodes.reduce((all: ClientNode[], nodeId: string) => {
    const node = getNode(board, nodeId);
    return all.concat(node ? _getLeaves(node, board) : []);
  }, []);
}
